import { ReactNode } from 'react';
import { ToastType } from './types';
import { StatusError, StatusInfoFill, StatusRelease } from '@vtbhome/juicyfront/indexIcon';
import { COLORS } from '../../config/colors/colors';

export const ICON_MAP: Record<ToastType, ReactNode> = {
    success: <StatusRelease />,
    error: <StatusError />,
    info: <StatusInfoFill />,
};

export const stylesWrapperByType = ({ $type }: { $type: ToastType }) => {
    switch ($type) {
        case 'success': {
            return `
                border: 1px solid ${COLORS.success_50};
            `;
        }
        case 'error': {
            return `
                border: 1px solid ${COLORS.error_60};
            `;
        }
        case 'info': {
            return `
                border: 1px solid ${COLORS.primary_60};
            `;
        }
        default:
            return '';
    }
};

export const stylesIconWrapperByType = ({ $type }: { $type: ToastType }) => {
    switch ($type) {
        case 'success': {
            return `
                    color: ${COLORS.success_50};
            `;
        }
        case 'error': {
            return `
                    color: ${COLORS.error_60};
            `;
        }
        case 'info': {
            return `
            color: ${COLORS.primary_60};
            `;
        }
        default:
            return '';
    }
};
